import { useLayoutEffect } from "react";
import { useActiveModule } from "./use-active-module";

const HUE_VAR = "--module-hue";

/**
 * Aktif modülün temasını <html>'e yansıtır:
 *   data-module="<id>"  → CSS'te `html[data-module]` / `[data-module="fashion"]` kancası
 *   --module-hue        → index.css'teki OKLCH türevleri buradan beslenir
 *
 * Modül yokken ikisi de kaldırılır; :root varsayılanı (indigo) devreye girer.
 * `--module-hue` kayıtlı property olduğu için değişim CSS transition ile
 * süpürülür — React tarafında animasyon yok.
 */
export const ModuleThemeSync = () => {
  const active = useActiveModule();
  const id = active?.id;
  const hue = active?.theme.hue;

  useLayoutEffect(() => {
    const root = document.documentElement;
    if (id !== undefined && hue !== undefined) {
      root.dataset.module = id;
      root.style.setProperty(HUE_VAR, String(hue));
    } else {
      delete root.dataset.module;
      root.style.removeProperty(HUE_VAR);
    }
  }, [id, hue]);

  return null;
};
